import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const homepageStepsMonitoring = [
  {
    element: '[data-onboarding="home-welcome"]',
    popover: {
      title: 'Watchful Dashboard',
      description:
        `This is your main dashboard. Use the shortcuts above to access <a href="${HELP_CENTER_LINKS.monitoring}" target="_blank" class="text-lime underline">monitoring</a> and support resources. Use Next to continue, or close the tour anytime using the X.`,
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="nav-bar"]',
    popover: {
      title: 'Navigation Bar',
      description:
        'The top bar shows your location in the platform, the environment you are working in, and live status updates. A navigation path will appear here as you move through the platform, letting you easily return to previous pages.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="nav-actions"]',
    popover: {
      title: 'Account & Shift Controls',
      description:
        'This menu includes your profile, shift status, and account options. Start or end your shift here, and open Settings to manage alert preferences.',
      side: 'bottom' as const,
      align: 'end' as const,
    },
  },
  {
    element: '[data-onboarding="nav-hamburger"]',
    popover: {
      title: 'Workspace Menu',
      description:
        'Open the menu to access Monitoring and other available features. Use it whenever you want to navigate to different areas.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="home-options"]',
    popover: {
      title: 'Quick Access',
      description:
        'Click a tile to access Monitoring, Support resources, or Live chat for assistance.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="monitoring-menu"]',
    popover: {
      title: 'Monitoring Portal',
      description:
        'Click the Monitoring tile to enter the live alert workspace. Here you can review events, resolve alerts, and manage incidents as they come in. You can restart guided tours anytime from the Shift Manager.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
];

export const homepageStepsAdmin = [
  {
    element: '[data-onboarding="home-welcome"]',
    popover: {
      title: 'Watchful Dashboard',
      description:
        `This is your main dashboard. Use the shortcuts above to access <a href="${HELP_CENTER_LINKS.monitoring}" target="_blank" class="text-lime underline">monitoring</a>, <a href="${HELP_CENTER_LINKS.alerts}" target="_blank" class="text-lime underline">alerts</a>, <a href="${HELP_CENTER_LINKS.devices}" target="_blank" class="text-lime underline">devices</a> and admin features. Use Next to continue, or close the tour anytime using the X.`,
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="nav-bar"]',
    popover: {
      title: 'Navigation Bar',
      description:
        'The top bar shows your location in the platform, the environment you are working in, and live status updates. A navigation path will appear here as you move through the platform, letting you easily return to previous pages.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="nav-actions"]',
    popover: {
      title: 'Account & Shift Controls',
      description:
        'This menu includes your profile, shift status, and account options. Start or end your shift here, and open Settings to manage alert preferences.',
      side: 'bottom' as const,
      align: 'end' as const,
    },
  },
  {
    element: '[data-onboarding="nav-hamburger"]',
    popover: {
      title: 'Workspace Menu',
      description:
        'Open the menu to move between key areas such as Monitoring, Sites, Devices, and Team management. Use it whenever you want to switch tasks.',
      side: 'right' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="home-options"]',
    popover: {
      title: 'Quick Access',
      description:
        'Hover to see a short summary, then click a tile to jump straight to that feature.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  }
];

export const homeRoutes: RouteConfig[] = [
  {
    id: 'home-monitoring',
    processName: ONBOARDING_KEYS.monitoringHome,
    match: (path: string) => path === '/' || path === '/home' || path === '/dashboard',
    steps: homepageStepsMonitoring,
  },
  {
    id: 'home-admin',
    processName: ONBOARDING_KEYS.monitoringHome,
    match: (path: string) => path === '/' || path === '/home' || path === '/dashboard',
    steps: homepageStepsAdmin,
  },
];
